export const commonEnvironment = {
  sendAccessToken: true,
  defaultConfigFile: '/assets/data/appConfig.default.json',
  envConfigFile: '/assets/data/appConfig.env.json',
};
